<template>
  <span
    :class="wrapClasses"
    :style="wrapStyles"
    tabindex="0"
    @blur="handleBlur"
    @click="toggle"
    @focus="handleFocus"
    @keydown.space="toggle">
    <input
      :name="name"
      type="hidden"
      :value="currentValue">
    <span class="s-switch-inner">
      <sIcon
        class="s-switch-icon"
        color="var(--white-color)"
        size="9"
        :spin="loading"
        :type="iconType"/>
    </span>
  </span>
</template>
<script>
import Form from '../mixins/form.js'
import emitter from '../mixins/emitter'


/**
 * Переключатель
 * @displayName Switch
 */
export default {
  name: 'sSwitch',
  componentName: 'sSwitch',
  mixins: [emitter, Form],
  props: {
    /**
     * Значение
     */
    value: {
      type: [String, Number, Boolean],
      default: false
    },
    /**
     * Значение для включенного состояния
     */
    trueValue: {
      type: [String, Number, Boolean],
      default: true
    },
    /**
     * Значение для выключенного состояния
     */
    falseValue: {
      type: [String, Number, Boolean],
      default: false
    },
    /**
     * Признак блокировки
     */
    disabled: {
      type: [String, Boolean],
      default: false
    },
    /**
     * @ignore
     */
    name: {
      type: String
    },
    /**
     * статус загрузки
     */
    loading: {
      type: Boolean,
      default: false
    },
    /**
     * цвет для включенного состояния
     */
    trueColor: {
      type: String
    },
    /**
     * цвет для выключенного состояния
     */
    falseColor: {
      type: String
    },
    /**
     * Выполняется после изменения
     */
    beforeChange: Function,
    /**
     * запускать ли проверку формы. При использовании FormItem
     */
    validateEvent: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      currentValue: this.value,
      hovering: false,
      focused: false,
    }
  },
  computed: {
    iconType() {
      if (this.loading) {
        return 'loading'
      }
      return this.currentValue === this.trueValue ? 'okay-arrow' : 'crossed'
    },
    wrapClasses() {
      const prefixCls = ['s-switch']
      return [
        `${prefixCls}`,
        {
          [`${prefixCls}-checked`]: this.currentValue === this.trueValue,
          [`${prefixCls}-disabled`]: this.inputDisabled,
          [`${prefixCls}-loading`]: this.loading,
          ['is-error']: this.validateState === 'error'
        }
      ]
    },
    wrapStyles() {
      const style = {}
      if (this.trueColor && this.currentValue === this.trueValue) {
        style['border-color'] = this.trueColor
        style['background-color'] = this.trueColor
      } else if (this.falseColor && this.currentValue === this.falseValue) {
        style['border-color'] = this.falseColor
        style['background-color'] = this.falseColor
      }
      return style
    },
  },
  methods: {
    handleBlur(event) {
      this.focused = false
      this.$emit('blur', event)
      if (this.validateEvent) {
        this.dispatch('sFormItem', 's.form.blur', [this.currentValue])
      }
    },
    handleFocus(event) {
      this.focused = true
      this.$emit('focus', event)
    },
    handleToggle() {
      const checked = this.currentValue === this.trueValue ? this.falseValue : this.trueValue
      this.currentValue = checked
      this.$emit('input', checked)
      this.$emit('update:value', checked)
      this.dispatch('FormItem', 'on-form-change', checked)
    },
    toggle(event) {
      event.preventDefault()
      if (this.inputDisabled || this.loading) {
        return
      }
      if (!this.beforeChange) {
        this.handleToggle()
        return
      }
      const before = this.beforeChange()
      if (before && before.then) {
        before.then(() => {
          this.handleToggle()
        })
      } else {
        this.handleToggle()
      }
    }
  },
  watch: {
    value(val) {
      if (val !== this.trueValue) {
        val = this.falseValue
      }
      if (this.validateEvent) {
        this.dispatch('sFormItem', 's.form.change', [val])
      }
      this.currentValue = val
    }
  }
}
</script>